import React from "react";
import {css, Theme} from "@emotion/react";

import {mt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {QuartileBarSVG} from "./atoms/QuartileBarSVG";

export interface IQuartileBarProps {
    firstQuartile: number;
    secondQuartile: number;
    thirdQuartile: number;
    avgPrice: number;
}

export const QuartileBar = (props: IQuartileBarProps) => {
    return (
        <>
            <QuartileBarSVG
                avgPrice={props.avgPrice}
                firstQuartile={props.firstQuartile}
                secondQuartile={props.secondQuartile}
                thirdQuartile={props.thirdQuartile}
            />
            <div css={mt(4)}>
                <Text css={disclaimerText} variant="info_txt_2">
                    Wykres pokazuje średnią cenę nieruchomości oraz przedział najczęściej występujących cen na rynku w danej lokalizacji.
                </Text>
            </div>
        </>
    );
};

const disclaimerText = (theme: Theme) => css`
    color: ${theme.colors.gray[500]};
`;
